/* Copyright (c) 2017 Backpack Health LLC */

import { TrackEvent } from '../../../utilities/UserMetrics';

import { types as groupTypes } from '../ducks/group';

const mixpanelMiddleware = () => next => action => {
  switch (action.type) {
    case groupTypes.RECEIVE_SEARCH:
      TrackEvent.groups.searchConducted(action.payload.query, action.payload.searchResults.length);
      break;
    default:
      break;
  }

  return next(action);
};

export default mixpanelMiddleware;
